const API_ORIGIN = process.env.VUE_APP_API_ORIGIN || 'https://backend.iugb-ci.com';
const API_BASE = process.env.NODE_ENV === 'development'
	? '/api/'
	: `${API_ORIGIN}/api/`;

export const URL_API = API_BASE;
export const URL = `${API_ORIGIN}/`;
export const URL_AUTH_API = process.env.NODE_ENV === 'development'
	? 'auth/'
	: `${API_ORIGIN}/api/auth/`;